'use client';

import { useCellServiceSession } from './useCellServiceSession';

/**
 * Session inputs every direct-CORS provenance-service hook needs.
 *
 * Thin alias for ``useCellServiceSession`` — provenance was the first
 * service to adopt the direct-CORS pattern and several call sites still
 * import this name. New services should import ``useCellServiceSession``
 * directly.
 */
export function useProvenanceSession() {
  return useCellServiceSession();
}
